import { FC } from 'react';
import {
  IconBottle,
  IconBrandSpeedtest,
  IconCat,
  IconCoins,
  IconHanger2,
  IconHeart,
  IconMoodUp,
  IconStar,
  IconUsers,
} from '@tabler/icons-react';

export interface FeatureProps {
  icon: FC<any>;
  title: string;
  description: string;
}

export const changesData = [
  {
    icon: IconBrandSpeedtest,
    title: 'content.changes.rates.title',
    description: 'content.changes.rates.description',
  },
  {
    icon: IconMoodUp,
    title: 'content.changes.enchant.title',
    description: 'content.changes.enchant.description',
  },
  {
    icon: IconCoins,
    title: 'content.changes.gold.title',
    description: 'content.changes.gold.description',
  },
  {
    icon: IconBottle,
    title: 'content.changes.consumables.title',
    description: 'content.changes.consumables.description',
  },
  {
    icon: IconCat,
    title: 'content.changes.dungeons.title',
    description: 'content.changes.dungeons.description',
  },
  {
    icon: IconHanger2,
    title: 'content.changes.styles.title',
    description: 'content.changes.styles.description',
  },
];

export const advantagesData = [
  {
    title: 'content.advantages.team.title',
    description: 'content.advantages.team.description',
    icon: IconUsers,
  },
  {
    title: 'content.advantages.honest.title',
    description: 'content.advantages.honest.description',
    icon: IconStar,
  },
  {
    title: 'content.advantages.support.title',
    description: 'content.advantages.support.description',
    icon: IconHeart,
  },
];
